import { Box, Card, Divider } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";

interface Props {
  title?: string;
  icon?: string;
  children: React.ReactNode;
  bottomMargin?: boolean;
}

const getIcon = (icon?: string) => {
  if (!icon) {
    return "";
  }
  switch (icon) {
    case "edit":
      return <EditOutlinedIcon sx={{ marginRight: 0.5 }} />;
    case "graph":
      return <AssessmentOutlinedIcon sx={{ marginRight: 0.5 }} />;
    case "list":
      return <ViewCompactIcon sx={{ marginRight: 0.5 }} />;
    default:
      return "";
  }
};

const BasicContainer = ({ children, icon, title, bottomMargin }: Props) => {
  return (
    <Card
      style={{
        borderRadius: 8,
        padding: 16,
        marginBottom: bottomMargin ? 24 : 0,
      }}
    >
      <Box sx={{ marginBottom: 2 }}>
        <h1>
          {getIcon(icon)}
          {title}
        </h1>
      </Box>
      <Divider />
      {children}
    </Card>
  );
};

export default BasicContainer;
